import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, Container, Typography } from '@mui/material';
// components
import ChangePasswordForm from '../sections/auth/changePassword/ChangePassword';
// sections

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function ChangePasswordPage() {
  return (
    <>
      <Helmet>
        <title>Change Password</title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="sm">
          <StyledContent>
            <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'space-between',justifyItems:'center'}}>
              <Typography variant="h4" gutterBottom>
                Change Password
              </Typography>
            </Box>
            <ChangePasswordForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
